import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import RouterLinkButton from 'components/router-link-button'
import RedeemIcon from 'components/material-symbol/icons/Redeem'
import EventNoteIcon from 'components/material-symbol/icons/EventNote'
import ConfirmationNumberOutlinedIcon from 'components/material-symbol/icons/ConfirmationNumber'
import {
  buildLessonPackBookingUrls,
  getLessonPackActionVisibility,
} from './lesson-pack-action-utils'
import { useStyles } from './styles'

const LessonPackCardActions = ({
  isGiftable,
  onGiftClick,
  lessonType,
  remainingCredits,
  lessonPackId,
  totalCredits,
  isUsedOrExpired = false,
}) => {
  const classes = useStyles()

  const bookingUrls = buildLessonPackBookingUrls(lessonType, remainingCredits)
  const { showBook, showBuyAnother } = getLessonPackActionVisibility({
    lessonType,
    totalCredits,
    remainingCredits,
    isUsedOrExpired,
  })

  return (
    <Box className={classes.cardFooter}>
      <Box className={classes.cardFooterActions}>
        {isGiftable && (
          <Tooltip title="Gift">
            <span className={classes.tooltipWrap}>
              <IconButton
                onClick={() => onGiftClick(lessonPackId)}
                aria-label="Gift"
                className={classes.outlinedIconButton}
              >
                <RedeemIcon fontSize="small" opticalSize={20} />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {showBuyAnother && bookingUrls && (
          <Tooltip title="Buy Another Pack">
            <span className={classes.tooltipWrap}>
              <RouterLinkButton
                to={bookingUrls.buyMoreVouchersUrl}
                variant="outlined"
                color="primary"
                aria-label="Buy Another Pack"
                className={classes.outlinedIconButton}
              >
                <ConfirmationNumberOutlinedIcon />
              </RouterLinkButton>
            </span>
          </Tooltip>
        )}
        {showBook && bookingUrls && (
          <RouterLinkButton
            to={bookingUrls.bookSessionUrl}
            variant="contained"
            color="primary"
            className={classes.actionButton}
            startIcon={<EventNoteIcon />}
          >
            Book
          </RouterLinkButton>
        )}
      </Box>
    </Box>
  )
}

export default LessonPackCardActions
